import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Badge,
  Button,
  Collapse,
  FormGroup,
  Input,
  Label,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  addSelectedFilter,
  deleteSelectedFilter,
} from '../../actions/Files';

import FiltersResetButton from './FiltersResetButton';

class FiltersFileOrientation extends Component {
  constructor(props) {
    super(props);

    this.handleChangeFilter = this.handleChangeFilter.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  handleChangeFilter(e) {
    const { value } = e.target;
    const {
      intl,
      handleChangeFilters,
      addFilter,
      removeFilter,
    } = this.props;

    let label = '';
    if (value === 'h') {
      label = intl.formatMessage({ defaultMessage: 'Horizontal' });
    }
    if (value === 'v') {
      label = intl.formatMessage({ defaultMessage: 'Vertical' });
    }
    if (value === 's') {
      label = intl.formatMessage({ defaultMessage: 'Square' });
    }

    removeFilter('orientation');
    addFilter({
      type: 'orientation',
      key: `${value}`,
      label,
      title: intl.formatMessage({ defaultMessage: 'Orientation' }),
    });

    handleChangeFilters({ orientation: value });
  }

  handleReset() {
    const {
      handleChangeFilters,
      clearSelectedFilters,
    } = this.props;
    handleChangeFilters({ orientation: null });
    clearSelectedFilters('orientation');
  }

  render() {
    const {
      intl,
      isOpen,
      filters,
      availableFilters,
      handleToggleFilter,
      prefix,
    } = this.props;

    if (availableFilters.length === 0) {
      return null;
    }

    return (
      <div className="files-filter upload-date-filter">
        <div className="filter-header">
          <Button onClick={handleToggleFilter} className="filter-title">
            <i className={`fal fa-angle-${isOpen ? 'up' : 'down'}`} />
            <span>{intl.formatMessage({ defaultMessage: 'Orientation' })}</span>
            {' '}
            {(filters.orientation &&
              !(_.isArray([filters.orientation]) && filters.orientation.length === 0)
            ) && (
              <Badge color="primary">
                {intl.formatMessage({ defaultMessage: '1' })}
              </Badge>
            )}
          </Button>
          {(filters.orientation &&
            !(_.isArray([filters.orientation]) && filters.orientation.length === 0)
          ) && (
            <FiltersResetButton
              handleReset={this.handleReset}
            />
          )}
        </div>
        <Collapse
          isOpen={isOpen}
          className="filter-body"
        >
          <div className="filter-form orientation-filter-form">
            {_.find(availableFilters, { key: 'h' }) && (
              <FormGroup>
                <Label for={`${prefix}radioOrientationHorizontal`} check>
                  <Input
                    type="radio"
                    name="orientation"
                    id={`${prefix}radioOrientationHorizontal`}
                    className="input-radio radio-s"
                    checked={filters.orientation === 'h'}
                    value="h"
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    {intl.formatMessage({ defaultMessage: 'Horizontal' })}
                  </span>
                </Label>
              </FormGroup>
            )}
            {_.find(availableFilters, { key: 'v' }) && (
              <FormGroup>
                <Label for={`${prefix}radioOrientationVertical`} check>
                  <Input
                    type="radio"
                    name="orientation"
                    id={`${prefix}radioOrientationVertical`}
                    className="input-radio radio-s"
                    checked={filters.orientation === 'v'}
                    value="v"
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    {intl.formatMessage({ defaultMessage: 'Vertical' })}
                  </span>
                </Label>
              </FormGroup>
            )}
            {_.find(availableFilters, { key: 's' }) && (
              <FormGroup>
                <Label for={`${prefix}radioOrientationSquare`} check>
                  <Input
                    type="radio"
                    name="orientation"
                    id={`${prefix}radioOrientationSquare`}
                    className="input-radio radio-s"
                    checked={filters.orientation === 's'}
                    value="s"
                    onChange={this.handleChangeFilter}
                  />
                  {' '}
                  <span>
                    {intl.formatMessage({ defaultMessage: 'Square' })}
                  </span>
                </Label>
              </FormGroup>
            )}
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  filters: props.customFilters || state.Files.filters,
});

const mapDispatchToProps = (dispatch, props) => ({
  addFilter: props.customAddFilter || ((filter) => {
    dispatch(addSelectedFilter(filter));
  }),
  removeFilter: props.customRemoveFilter || ((type) => {
    dispatch(deleteSelectedFilter(type));
  }),
  clearSelectedFilters: props.customClearSelectedFilters || ((type) => {
    dispatch(deleteSelectedFilter(type, null));
  }),
});

FiltersFileOrientation.propTypes = {
  intl: PropTypes.object.isRequired,
  filters: PropTypes.object.isRequired,
  addFilter: PropTypes.func.isRequired,
  removeFilter: PropTypes.func.isRequired,
  clearSelectedFilters: PropTypes.func.isRequired,
  availableFilters: PropTypes.array.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleChangeFilters: PropTypes.func.isRequired,
  handleToggleFilter: PropTypes.func.isRequired,
  prefix: PropTypes.string,
};

FiltersFileOrientation.defaultProps = {
  prefix: '',
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(FiltersFileOrientation));
